export default {"src":"/_next/static/media/faq-icon12.c35c3c2a.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};